import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api/BanksApi';
import { BANK_STAFF_KEY } from 'hooks/keys';
import { useUser } from 'hooks/queries';
import { getFiBankStore } from 'stores/FiBankStore';

export function useBankStaff({ shouldNotifyOnChange = true }: { shouldNotifyOnChange?: boolean } = {}) {
  const banksApi = new BanksApi();
  const bankStore = getFiBankStore();
  const { userBankId } = useUser();

  const { data: bankStaff, isLoading: isLoadingBankStaff } = useQuery({
    enabled: !!userBankId.length,
    queryKey: [BANK_STAFF_KEY, userBankId],
    queryFn: () => banksApi.getBankStaff(userBankId),
    ...(!shouldNotifyOnChange && { notifyOnChangeProps: [] })
  });

  useEffect(() => {
    if (bankStaff && Array.isArray(bankStaff)) {
      bankStore.setStaff(bankStaff);
      bankStore.toggleStaffLoaded(true);
    }
  }, [bankStaff]);

  return { bankStaff, isLoadingBankStaff };
}
